import { useLocation } from "react-router-dom";
import NavMenu from "./Nav";
import servicosImagens from "../../servicos/servicos-imagens";
import { useEffect, useRef, useState } from "react";
import { useContext } from "react";
import AuthContext from "../../servicos/autorizacao/AuthContex";
import servicosProduto from "../../servicos/servicos-produto";
import servicosColaborador from "../../servicos/servicos-colaborador";
import { ToastContainer, toast } from "react-toastify";
import NavMobile from "./NavMobile";
import { basePath } from "../../utils/baseUrl";
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';

const CardProduto = () => {
    const { user } = useContext(AuthContext);
    const [listaTamanhos, setListaTamanhos] = useState([]);
    const location = useLocation();
    const [produto] = useState(location.state.produto);
    const [todosProdutos, setTodosProdutos] = useState([]);
    const [imagensProduto, setImagensProduto] = useState([]);
    const [imagemSelecionada, setImagemSelecionada] = useState(`${basePath}/${produto.filename}` || `${basePath}/${location.state.produto.filename}`);
    const [pontuacaoAtual, setPontuacaoAtual] = useState();
    const tamanho = useRef();

    useEffect(() => {
        const getDados = () => {
            servicosColaborador.getTotalPontos(user.id)
                .then(response => {
                    if (response.status === 200) {
                        setPontuacaoAtual(response.data.pontosAtivos)
                    }
                }).catch(error => {
                    console.log(error);
                })
        }
        getDados();
    }, [user.id]);

    useEffect(() => {
        const lista = [];
        servicosProduto.listarTodosCategoria1().then(response => {
            if (response.status === 200) {
                for (const item of response.data) {
                    if (item.nome === produto.Produto[0].nome && item.estoque > 0 && item.tamanho !== '') {
                        lista.push(item);
                    }
                }
                setListaTamanhos(lista);
                setTodosProdutos(response.data)
            }
        })
    }, [produto]);



    useEffect(() => {
        servicosImagens.listarPorIdProduto(produto.id_produto).then(response => {
            if (response.status === 200) {
                setImagensProduto(response.data);
            }
        }).catch(e => console.log(e));
    }, [produto.id_produto]);


    const SelectTamanho = () => {
        if (listaTamanhos.length > 0) {
            return <>
                <select className="form-select w-25 mb-4" ref={tamanho} aria-label="Exemplo de select simples">
                    {listaTamanhos.map(item => {
                        return (
                            <option key={item.id_produto}>{item.tamanho}</option>
                        )
                    })}
                </select>
            </>
        }
    }



    function adicionarAoCarrinho(produto) {
        let flagMax = false;
        if (tamanho?.current?.value !== undefined) {
            todosProdutos.map(item => {

                if (item.nome === produto.produto.Produto[0].nome && item.tamanho === tamanho?.current?.value) {
                    if (item.estoque >= 1) {
                        produto.produto.id_produto = item.id_produto;
                        produto.produto.Produto[0] = item;
                        return produto;
                    } else {
                        flagMax = true;
                        return toast.warning('Quantidade informada ultrapassa o estoque atual');
                    }
                } else {
                    return null;
                }
            })
        }

        if (!flagMax) {
            if (1 <= produto.produto.Produto[0].estoque) {
                let carrinho = JSON.parse(localStorage.getItem('carrinho')) || { produtos: [] };

                let produtoEncontrado = carrinho.produtos.find(item => item.produto.id_produto === produto.produto.id_produto);

                if (produtoEncontrado) {
                    produtoEncontrado.qtd = 1;
                } else {
                    carrinho.produtos.push(produto);
                }

                toast.success(`Adicionado ${produto.produto.Produto[0].nome}  qtd: 1`)
                localStorage.setItem('carrinho', JSON.stringify(carrinho));
            } else {
                return toast.warning('Quantidade informada ultrapassa o estoque atual');

            }
        }

    }


    return <>
        <ToastContainer />
        <NavMenu />
        <div className="d-flex align-items-center  justify-content-center card-produto container mt-4">
            <div style={{ width: 300, height: 650 }} className="shadow-sm card-imagem container card d-flex justify-content-center col align-items-center">
                <div className="d-flex align-items-center row justify-content-center">
                    <span style={{ position: "absolute", marginLeft: 0, bottom: 0 }}>imagens ilustrativa</span>

                    <img style={{ width: 300 }} src={imagemSelecionada} className="card-img-top my-5 imagem-selecionada" alt="..." />
                </div>
                <div className="d-flex justify-content-center lista-imagens">
                    {imagensProduto.length > 1 && imagensProduto.map(item => {
                        return (<div key={item.filename} className={`border-1 border border-secondary mx-1 ${imagemSelecionada === `${basePath}/${item.filename}` ? 'item-selecionado' : ''} `}>
                            <img onClick={() => setImagemSelecionada(`${basePath}/${item.filename}`)} style={{ width: 150, height: 150 }} src={`${basePath}/${item.filename}`} alt={item.filename} />
                        </div>)
                    })}
                </div>
            </div>
            <div style={{ width: 300, height: 500 }} className="shadow-sm card-detalhes card d-flex justify-content-center align-items-center">
                <div className="w-100 d-flex mt-3 justify-content-center align-items-center pt-2">
                    <span className="me-4">
                        Saldo: {` ${pontuacaoAtual}  milhas`}
                    </span>
                    <a href="/CarrinhoSimples">

                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="#753BBD" className="bi bi-cart-check-fill" viewBox="0 0 16 16">
                            <path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-1.646-7.646-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L8 8.293l2.646-2.647a.5.5 0 0 1 .708.708z" />
                        </svg>
                    </a>
                </div>
                <h5 className="card-title  subtitulo text-center">{produto.Produto[0].nome}</h5>
                <p className="card-text subtitulo2 text-center">{produto.Produto[0].milhas} milhas</p>
                <SelectTamanho />
                {produto?.Produto[0].estoque < 1 && listaTamanhos.length < 1 ? <span style={{color: 'red', fontSize: 16}}>Produto esgotado {<SentimentVeryDissatisfiedIcon sx={{mb: "4px"}} />}</span> : <button onClick={() => adicionarAoCarrinho({ produto: produto, qtd: 1 })} className="btn w-50 btn-icones btn-primary mb-4 ">
                    Adicionar ao carrinho
                </button> }

                

            </div>
        </div>
        <div className="text-center mt-5">
            <span><a href="/Shopping" className="subtitulo rounded-3 p-1">Conheça outros produtos</a></span>
        </div>
        <NavMobile />
    </>
}

export default CardProduto;